export default __webpack_public_path__ + "static/media/graphic-design.3d3a7ca8.png";